<nz-form-item>
  <span [class.required-label]="required">{{label}}</span>
  <nz-form-control [nzValidateStatus]="convertErrorsNz[inputFormControl.status]">
    <input nz-input [colorPicker]="inputFormControl.value" [cpPosition]="'bottom'" (colorPickerChange)="onChange($event)" [formControl]="asFormControl(inputFormControl)"/>
    <app-form-item-error [touched]="inputFormControl.touched" [errors]="inputFormControl.errors"></app-form-item-error>
  </nz-form-control>
</nz-form-item>
